import { render, staticRenderFns } from "./WhiteLabel.vue?vue&type=template&id=48db273e&scoped=true&"
import script from "./WhiteLabel.vue?vue&type=script&lang=js&"
export * from "./WhiteLabel.vue?vue&type=script&lang=js&"
import style0 from "./WhiteLabel.vue?vue&type=style&index=0&id=48db273e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48db273e",
  null
  
)

export default component.exports